<form [formGroup]="form" class="flex flex-col gap-4">
  <div class="flex justify-between gap-4">
    <div class="flex-[0_1_370px] flex flex-col gap-3 ">
      <div class="flex items-start gap-3 ">
        <div class="flex-initial">
          <beautyapp-time-picker
            label="{{ 'calendar.form.startingTime' | translate }}"
            placeholder="{{ 'calendar.form.startingTime' | translate }}"
            formControlName="startTime"
            required
            size="large"
          ></beautyapp-time-picker>
        </div>
        <div class="flex-initial">
          <beautyapp-time-picker
            label="{{ 'calendar.form.finishingTime' | translate }}"
            placeholder="{{ 'calendar.form.finishingTime' | translate }}"
            formControlName="endTime"
            required
            size="large"
          ></beautyapp-time-picker>
        </div>
      </div>
      @if (form.getError('dateRange')) {
        <div class="text-red-500 text-sm">
          {{ 'calendar.form.errors.dateRangeError' | translate }}
        </div>
      }
      <div class="flex flex-col gap-3 ">
        <div class="flex-1">
          <beautyapp-select
            formControlName="employeeId"
            [data]="visitAddFacade.employee$ | async"
            label="{{ 'calendar.form.employee' | translate }}"
            placeholder="{{ 'calendar.form.employee' | translate }}"
            valueMember="id"
            displayMember="fullName"
            required
            size="large"
          ></beautyapp-select>
        </div>
      </div>
    </div>
  </div>

  <!-- Availability Conflicts Warning -->
  @if (hasAvailabilityConflicts()) {
    <nz-alert
      nzType="warning"
      [nzMessage]="'გაფრთხილება: კონფლიქტები აღმოჩენილია'"
      [nzDescription]="conflictsTemplate"
      nzShowIcon
    ></nz-alert>
    <ng-template #conflictsTemplate>
      <ul class="list-disc pl-4">
        @for (conflict of availabilityConflicts(); track conflict.id) {
          <li [class]="conflict.severity === 'hard' ? 'text-red-600' : 'text-orange-600'">
            @switch (conflict.type) {
              @case ('employee') {
                <strong>თანამშრომელი:</strong> {{ getConflictMessage(conflict) }}
              }
              @case ('room') {
                <strong>ოთახი:</strong> {{ getConflictMessage(conflict) }}
              }
              @case ('service') {
                <strong>სერვისი:</strong> {{ getConflictMessage(conflict) }}
              }
              @case ('schedule') {
                <strong>განრიგი:</strong> {{ getConflictMessage(conflict) }}
              }
              @case ('break') {
                <strong>შესვენება:</strong> {{ getConflictMessage(conflict) }}
              }
            }
          </li>
        }
      </ul>
    </ng-template>
  }
</form>

<div *nzModalFooter>
  <button
    nz-button
    nzType="default"
    (click)="modalRef.triggerCancel()"
    class="font-firago firago-uppercase"
  >
    {{ 'buttons.close' | translate }}
  </button>
  @if (hasAvailabilityConflicts()) {
    <button
      nz-button
      nzType="primary"
      nzDanger
      [disabled]="form.invalid"
      [nzLoading]="loading()"
      (click)="confirmDespiteConflicts()"
      class="font-firago firago-uppercase"
    >
      მაინც შენახვა
    </button>
  } @else {
    <button
      nz-button
      nzType="primary"
      [disabled]="form.invalid"
      [nzLoading]="loading() || isCheckingAvailability()"
      (click)="submit()"
      class="font-firago firago-uppercase"
    >
      {{ isCheckingAvailability() ? 'შემოწმება...' : ('buttons.save' | translate) }}
    </button>
  }
</div>
